import { render } from "./CalendarEventOfferChooser.vue?vue&type=template&id=1ad0c567&scoped=true"
import script from "./CalendarEventOfferChooser.vue?vue&type=script&lang=ts"
export * from "./CalendarEventOfferChooser.vue?vue&type=script&lang=ts"

import "./CalendarEventOfferChooser.vue?vue&type=style&index=0&id=1ad0c567&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ad0c567"

export default script